import { classesConstants as pg } from "../../../constants/classes";

const initialState = {
  loading: true,
  data: [],
  ue: null,
  ec: null,
  ecue: null,
  ues: [],
  ecs: [],
  ecues: [],
  semestres: [],
  allSemestres: [],
  commun: [],
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case pg.GET_PROGRAMME:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case pg.GET_COMMUN:
      return {
        ...state,
        loading: false,
        commun: payload,
      };
    case pg.GET_UES:
      return {
        ...state,
        loading: false,
        ues: payload,
      };
    case pg.GET_UE:
      return {
        ...state,
        loading: false,
        ue: payload,
      };
    case pg.GET_ECS:
      return {
        ...state,
        loading: false,
        ecs: payload,
      };
    case pg.GET_EC:
      return {
        ...state,
        loading: false,
        ec: payload,
      };
    case pg.GET_ECUES:
      return {
        ...state,
        loading: false,
        ecues: payload,
      };
    case pg.GET_ECUE:
      return {
        ...state,
        loading: false,
        ecue: payload,
      };
    case pg.GET_SEMESTRES:
      return {
        ...state,
        loading: false,
        semestres: payload,
      };
    case pg.GET_ALL_SEMESTRES:
      return {
        ...state,
        loading: false,
        allSemestres: payload,
      };
    default:
      return state;
  }
}
